import {useEffect, useState} from "react";

import PaymentComponent from "../../components/checkout/checkoutFlow/paymentComponent";
import FooterComponent from "../../components/home/FooterComponent";

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {readCart} from "../../modules/checkoutHelpers";
import {sendSlackMessageTracked} from "../../models/notifications";
import {ProductsData} from "../../data/productsData";

// TODO: Testing
// const stripe = loadStripe("pk_test_51OXEZbEtOurAbnzKrvuWEULuMoOoc0dMClXeCnQRoz1i5DWGwO7A0V17QuUBdAT7jKkeUvAmXK9c1hIsWQ4Edba600EKImzKuv");

// TODO: Production
const stripe = loadStripe("pk_live_51OXEZbEtOurAbnzKXXYZFqVfLj23VLaRFHwCGS8qbJ4FcJDHOppkeiOv35ZcNdMMBKKkXclsazoocVSA5pd1Ofrl003h5zKB0X");

export default function PaymentPage() {

    const [options, setOptions] = useState(null)
    const [cartData, setCartData] = useState(null)


    useEffect(() => {
        if (!options) {

            readCart((currentCartData) => {
                setCartData(currentCartData)

                const customerEmail = currentCartData?.checkout_form_data?.email
                const isMonthlyFrequency = Boolean(currentCartData?.isMonthlyFrequency)

                // Prepares the priceIds for Stripe checkout
                const productLineItems = currentCartData?.productLineItems || []
                let priceIds = []
                for(const productLineItem of productLineItems) {
                    const productIndex = productLineItem.productIndex
                    // Loops through ProductsData
                    for (const product of ProductsData) {
                        if (product.id === productIndex) {
                            priceIds.push({
                                // TODO: Testing
                                // price: isMonthlyFrequency ? product.priceIdMonthTest : product.priceIdAnnualTest,

                                // TODO: Production
                                price: isMonthlyFrequency ? product.priceIdMonth : product.priceIdAnnual,
                            })
                        }
                    }
                }
                // fetchOptions("pabloo@gmail.com", [{"price": "price_1OXfzjEtOurAbnzKiNhLkIKc"}])
                fetchOptions(customerEmail, priceIds)
                sendSlackMessageTracked(`3️⃣ Visitor is visiting the checkout page. Cart data: ${JSON.stringify(currentCartData)}`)

            })
        }
    }, [])


    return (
        <div>

            {
                options ?
                <Elements
                    stripe={stripe}
                    options={options}
                >
                    <PaymentComponent/>
                </Elements> :
                    skeletonScreen()
            }
            <FooterComponent/>
        </div>
    )

    function skeletonScreen() {
        return (
            <div className="p-12 m-4 sm:m-24">
                <div role="status"
                     className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center">

                    <div className="w-full">
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[440px] mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[460px] mb-2.5"></div>
                        <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
                    </div>
                    <div
                        className="flex items-center justify-center w-full h-48 bg-gray-300 rounded-sm sm:w-96 dark:bg-gray-700">
                        <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true"
                             xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path
                                d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                        </svg>
                    </div>
                </div>
            </div>
        )
    }


    function fetchOptions(customerEmail, priceIDs) {
        const appearance = {
            theme: 'flat',
            variables: {colorPrimaryText: '#262626'}
        }

        const myHeaders = new Headers();
        myHeaders.append("accept", "application/json");
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "customer_email": customerEmail || "notFound@pabloo.com",
            items: priceIDs,
            // "customer_email": "testing@pabloo.com",
            // items: [{
            //     'price': "price_1OXfzjEtOurAbnzKiNhLkIKc",
            // }]
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch('https://server.pabloo.com/payments/create_payment_intent', requestOptions)
            .then((response) => response.json())
            .then((json) => {
                const client_secret = json.client_secret

                setOptions({
                    clientSecret: client_secret,
                    appearance
                })
            })
    }
}